import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { Router } from '@angular/router';
import { IdSystemService } from './id-system';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatorService {

  private idSystem = inject(IdSystemService)
  private router = inject(Router)
  private authSubject = new BehaviorSubject<boolean>(this.idSystem.isAuthed)
  readonly auth$ = this.authSubject.pipe(distinctUntilChanged())

  get isAuthed()     { return this.idSystem.isAuthed }
  get accessToken()  { return this.idSystem.accessToken }

  constructor() {
    this.idSystem.events$.subscribe(event => {
      if (event.event === 'login') {
        console.log('ID SYSTEM login', event)
        this.authSubject.next(true)
      }
      if (event.event === 'logout') {
        console.log('ID SYSTEM logout', event)
        this.authSubject.next(false)
      }
      if (event.event === 'refresh') {
        console.log('ID SYSTEM refresh', event)
      }
      if (event.event === 'error') {
        console.log('ID SYSTEM error', event)
      }
    })
  }

  login() {
    this.idSystem.login({
      lang: localStorage['lang'],
      theme: localStorage['theme']
    }).subscribe()
  }

  logout() {
    this.idSystem.logout().subscribe(() => this.router.navigateByUrl('/'))
  }

  idpLogin(service: string, idpData: unknown, lang: string, skipLauncher: boolean) {
    return this.idSystem.idpLogin(service, idpData, lang, skipLauncher)
  }

}
